module.exports = __webpack_public_path__ + "img/dairy_free-off.f4826c4d.svg";